<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  class="flex-auto gt-xs:pr-3 w-full"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
    >
      {{ fieldDef.label }}
    </span>
  </mat-label>
  <div class="w-full" (click)="edit()" (focus)="edit()">
    @if (fieldDef.name === 'address_string') {
      <input
        matInput
        google-place
        placeholder="Enter a location"
        [ngClass]="{ disabled: isDisabled }"
        [maxLength]="1024"
        [mask]="mask$ | async"
        [(ngModel)]="value"
        (keyup.enter)="$event.preventDefault()"
        (blur)="$event.preventDefault()"
        [disabled]="isDisabled"
        (ngModelChange)="onNgModelChange()"
        (onSelectParts)="onSetAddress($event)"
        data-cy="form-panel-text-form-field"
        [class.blurred]="fieldDef.meta?.value_hidden && !editing"
      />
    } @else {
      <input
        #inputControl
        matInput
        [ngClass]="{ disabled: isDisabled }"
        [maxLength]="1024"
        [mask]="mask$ | async"
        [(ngModel)]="value"
        (keyup.enter)="onBlur()"
        (blur)="onBlur()"
        [disabled]="isDisabled"
        (ngModelChange)="onNgModelChange()"
        data-cy="form-panel-text-form-field"
        [class.blurred]="fieldDef.meta?.value_hidden && !editing"
      />
    }
  </div>
</mat-form-field>
